import { aiInRecruitingBannerData } from 'constants/AiInRecruiting'
import Image from 'next/image'
import styles from './AiInRecruitingBanner.module.css'

const AiInRecruitingBanner = () => {
  const { title, titleHighlight, subtitle, image, imageAlt, paragraphs } =
    aiInRecruitingBannerData

  return (
    <section className={styles.bannerSection}>
      <div className="container">
        <h1 className={styles.bannerTitle}>
          {title}{' '}
          <span className={styles.bannerTitleBlue}>
            {titleHighlight}
            <svg
              className={styles.bannerTitleUnderline}
              width="135"
              height="9"
              viewBox="0 0 135 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M133.971 7.77784C121.905 4.22422 109.84 2.6706 90.3187 1.4772C70.7977 0.283802 44.1869 1.55831 27.8762 2.78519C11.5654 4.01207 6.36103 5.15271 0.998973 6.32791"
                stroke="#0010F1"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </span>
        </h1>
        <p className={styles.bannerSubtitle}>{subtitle}</p>
        <div className="row align-items-center">
          <div className="col-12 col-lg-6 mb-4 mb-lg-0">
            <div className="pe-lg-4">
              <Image
                src={image}
                alt={imageAlt}
                width={740}
                height={420}
                className={styles.bannerImage}
              />
            </div>
          </div>
          <div className="col-12 col-lg-6">
            {paragraphs.map((text, i) => (
              <p key={i} className={styles.bannerText}>
                {text}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingBanner
